import { observer } from 'mobx-react-lite'
import { Alert } from 'shared/ui'
import { Label } from 'shared/ui/Label'
import { RadioOptions } from 'shared/ui/Radio'
import { type CancelInviteStore } from 'pages/settings/pages/members/ui/actions/cancelInvite/ui/CancelInviteModal/store/CancelInviteStore'

type ICancelInviteModalProps = {
  store: CancelInviteStore
}

export const CancelInviteModal = observer(({ store }: ICancelInviteModalProps) => {
  const { seatOption, seatOptions, onSetSeatOption, isSingleInviteCancel, invitesCount } = store

  return (
    <>
      <Alert
        item={{
          type: 'alert',
          desc: isSingleInviteCancel
            ? 'Cancel this invite?'
            : `Cancel ${invitesCount} invite${isSingleInviteCancel ? '' : 's'}?`,
        }}
        marginBottom={24}
      />
      <Label
        label={{
          text: 'What would you like to do with the seat?',
        }}
        marginBottom={4}
      />
      <RadioOptions options={seatOptions} active={seatOption} onChange={onSetSeatOption} />
    </>
  )
})
